import { useState, useEffect } from 'react';
import { merchantsService } from '../../../services';
import { MerchantRate } from '../../../types';

export const useMerchantRates = () => {
  const [rates, setRates] = useState<MerchantRate[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchRates = async () => {
    try {
      setLoading(true);
      const data = await merchantsService.getAllMerchantRates();
      setRates(data);
      setError(null);
    } catch (err: any) {
      setError(err.message || 'Ошибка при загрузке ставок');
    } finally {
      setLoading(false);
    }
  };

  const patchRate = (id: string, patch: Partial<MerchantRate>) => {
    setRates((prev) =>
      prev.map((rate) =>
        rate.id === id
          ? {
              ...rate,
              ...patch,
            }
          : rate,
      ),
    );
  };

  useEffect(() => {
    fetchRates();
  }, []);

  return {
    rates,
    loading,
    error,
    refetch: fetchRates,
    patchRate,
  };
}; 